const SLATE_TONES = {
  quiet: [56, 66, 94],
  low: [78, 104, 152],
  mid: [84, 162, 176],
  high: [146, 194, 220],
  full: [198, 234, 240],
};

const WARM_TONES = {
  quiet: [48, 58, 62],
  low: [76, 98, 96],
  mid: [76, 160, 110],
  high: [158, 188, 168],
  full: [214, 232, 214],
};

const DAWN = {
  sky: { top: "#525b73", mid: "#5e6477", bottom: "#6e6f80" },
  ink: "#f5f3ee",
  inkMuted: "rgba(245,243,238,0.74)",
  star: "231,230,243",
  glow: "202,224,255",
  floor: "110,111,128",
  tip: [212, 230, 255],
  tones: SLATE_TONES,
};

const DUSK = {
  sky: { top: "#0f1115", mid: "#171719", bottom: "#271b1e" },
  ink: "#f5f3ee",
  inkMuted: "rgba(245,243,238,0.74)",
  star: "231,230,243",
  attention: "255,226,214",
  glow: "250,170,118",
  floor: "6,8,12",
  tip: [150, 148, 190],
  tones: WARM_TONES,
};

const SKY_SCENES = {
  dusk: DUSK,
  moonlight: {
    beamProfile: "monochrome",
    light: { diffusion: 1.1, coreLift: 0.04 },
    sky: { top: "#121416", mid: "#1b1e22", bottom: "#303237" },
    ink: "#f5f4f0",
    inkMuted: "rgba(245,244,240,0.76)",
    star: "231,233,236",
    attention: "249,247,239",
    glow: "218,225,235",
    floor: "12,14,17",
    tip: [225, 230, 236],
    tones: {
      quiet: [49, 54, 62],
      low: [78, 86, 96],
      mid: [129, 142, 158],
      high: [185, 197, 211],
      full: [229, 234, 240],
    },
  },
  aurora: {
    beamProfile: "monochrome",
    light: { diffusion: 0.75, coreLift: 0.02 },
    sky: { top: "#101322", mid: "#191d32", bottom: "#292a40" },
    ink: "#f1faf6",
    inkMuted: "rgba(241,250,246,0.78)",
    star: "215,231,248",
    attention: "223,255,239",
    glow: "64,236,167",
    floor: "10,13,24",
    tip: [89, 245, 183],
    tones: {
      quiet: [26, 67, 58],
      low: [34, 108, 81],
      mid: [39, 173, 115],
      high: [54, 222, 150],
      full: [111, 249, 188],
    },
  },
  glacier: {
    beamProfile: "monochrome",
    light: { diffusion: 1.3, coreLift: 0.12 },
    sky: { top: "#1f212a", mid: "#30333d", bottom: "#464954" },
    ink: "#f5f9ff",
    inkMuted: "rgba(245,249,255,0.8)",
    star: "230,237,255",
    attention: "240,252,255",
    glow: "196,232,252",
    floor: "20,21,27",
    tip: [206, 239, 255],
    tones: {
      quiet: [50, 67, 79],
      low: [74, 107, 126],
      mid: [105, 162, 191],
      high: [155, 210, 233],
      full: [214, 243, 252],
    },
  },
  sunset: {
    beamProfile: "monochrome",
    light: { diffusion: 1.2, coreLift: 0.05 },
    sky: { top: "#242235", mid: "#34324a", bottom: "#554653" },
    ink: "#fff7e8",
    inkMuted: "rgba(255,247,232,0.8)",
    star: "241,227,239",
    attention: "255,241,203",
    glow: "249,203,118",
    floor: "24,21,34",
    tip: [255, 220, 147],
    tones: {
      quiet: [74, 59, 44],
      low: [118, 87, 51],
      mid: [186, 135, 64],
      high: [231, 184, 102],
      full: [255, 225, 162],
    },
  },
  nebula: {
    beamProfile: "monochrome",
    light: { diffusion: 0.8, coreLift: 0.02 },
    sky: { top: "#10181b", mid: "#18272a", bottom: "#273b3b" },
    ink: "#fcf3ff",
    inkMuted: "rgba(252,243,255,0.78)",
    star: "222,240,237",
    attention: "252,224,255",
    glow: "204,117,255",
    floor: "9,17,20",
    tip: [207, 135, 255],
    tones: {
      quiet: [62, 40, 77],
      low: [100, 53, 133],
      mid: [146, 65, 200],
      high: [184, 101, 239],
      full: [215, 155, 255],
    },
  },
  ember: {
    beamProfile: "monochrome",
    light: { diffusion: 0.9, coreLift: 0.02 },
    sky: { top: "#17181a", mid: "#23272a", bottom: "#353c3d" },
    ink: "#fff3e9",
    inkMuted: "rgba(255,243,233,0.78)",
    star: "239,230,219",
    attention: "255,224,192",
    glow: "255,131,76",
    floor: "15,17,19",
    tip: [255, 153, 97],
    tones: {
      quiet: [75, 42, 30],
      low: [129, 57, 35],
      mid: [204, 79, 41],
      high: [242, 117, 62],
      full: [255, 171, 110],
    },
  },
  chartreuse: {
    beamProfile: "monochrome",
    light: { diffusion: 0.8, coreLift: 0.02 },
    sky: { top: "#19181c", mid: "#26242c", bottom: "#39333d" },
    ink: "#f7f8ed",
    inkMuted: "rgba(247,248,237,0.78)",
    star: "238,231,247",
    attention: "241,252,208",
    glow: "197,223,65",
    floor: "16,15,21",
    tip: [216, 239, 104],
    tones: {
      quiet: [54, 61, 27],
      low: [91, 108, 29],
      mid: [145, 169, 28],
      high: [191, 216, 50],
      full: [228, 245, 126],
    },
  },
  blush: {
    beamProfile: "monochrome",
    light: { diffusion: 1.15, coreLift: 0.06 },
    sky: { top: "#1e2322", mid: "#2d3531", bottom: "#43483d" },
    ink: "#fff3f0",
    inkMuted: "rgba(255,243,240,0.8)",
    star: "240,239,222",
    attention: "255,224,226",
    glow: "241,162,176",
    floor: "20,25,22",
    tip: [248, 187, 198],
    tones: {
      quiet: [70, 47, 49],
      low: [113, 70, 76],
      mid: [178, 108, 120],
      high: [224, 154, 166],
      full: [250, 204, 211],
    },
  },
  lilac: {
    beamProfile: "monochrome",
    light: { diffusion: 1.35, coreLift: 0.12 },
    sky: { top: "#24201e", mid: "#35302b", bottom: "#4c443a" },
    ink: "#faf5ff",
    inkMuted: "rgba(250,245,255,0.8)",
    star: "243,232,219",
    attention: "244,234,255",
    glow: "211,197,244",
    floor: "25,21,19",
    tip: [224, 212, 251],
    tones: {
      quiet: [57, 51, 75],
      low: [91, 80, 124],
      mid: [141, 125, 184],
      high: [184, 166, 222],
      full: [226, 212, 250],
    },
  },
  sky: {
    beamProfile: "monochrome",
    light: { diffusion: 0.85, coreLift: 0.03 },
    sky: { top: "#111214", mid: "#1a1c20", bottom: "#2b2c31" },
    ink: "#f2f6ff",
    inkMuted: "rgba(242,246,255,0.78)",
    star: "230,235,247",
    attention: "222,239,255",
    glow: "100,170,255",
    floor: "9,11,14",
    tip: [133, 196, 255],
    tones: {
      quiet: [28, 45, 74],
      low: [35, 74, 130],
      mid: [42, 115, 201],
      high: [69, 160, 242],
      full: [141, 207, 255],
    },
  },
};
const DEFAULT_SKY_PALETTE = "glacier";
const SKY_PALETTE_OPTIONS = [
  { id: "glacier", label: "Starlight", description: "Icy light drifts through a smoky twilight sky." },
  { id: "moonlight", label: "Moonlight", description: "Silver light fills a quiet charcoal sky." },
  { id: "dusk", label: "Nightfall", description: "Soft sage light rises through a warm night sky." },
  { id: "lilac", label: "Twilight", description: "Pale lavender light drifts through a warm taupe sky." },
  { id: "blush", label: "Rose Moon", description: "Soft rose light fills a muted olive sky." },
  { id: "sunset", label: "Sunset", description: "Honey gold light fills a dusty blue dusk." },
  { id: "ember", label: "Solar", description: "Copper light burns against cool charcoal." },
  { id: "aurora", label: "Aurora", description: "Vivid jade ribbons rise through deep indigo." },
  { id: "sky", label: "Orbit", description: "Clear blue ribbons illuminate a graphite sky." },
  { id: "nebula", label: "Nebula", description: "Electric violet light rises through a dark mineral sky." },
  { id: "chartreuse", label: "Comet", description: "Sharp lime light illuminates a smoky graphite sky." },
];

const PALETTES = { dawn: DAWN, ...SKY_SCENES };

export const SKY_THEMES = SKY_PALETTE_OPTIONS;
export { DEFAULT_SKY_PALETTE };

export function resolveSkyPalette(id) {
  return PALETTES[id] ?? PALETTES[DEFAULT_SKY_PALETTE];
}

export function storedSkyPalette(value) {
  return SKY_THEMES.find((theme) => theme.id === value)?.id ?? DEFAULT_SKY_PALETTE;
}

// Doses carry almost all of a week's warmth; a weigh-in or photo is a bonus. An
// unknown kind gets the bonus weight so the server can add kinds without dimming
// anyone.
const WEEK_WEIGHTS = {
  log_doses: 0.8,
  weigh_in: 0.1,
  progress_photos: 0.1,
};

function weightFor(kind) {
  return WEEK_WEIGHTS[kind] ?? 0.1;
}

// Normalized by the kinds the cohort tracks, so a dose-only cohort still reaches
// a full week and a user who skips photos lands bright rather than punished.
export function weekWarmth(items) {
  let available = 0;
  let earned = 0;
  for (const item of items) {
    const weight = weightFor(item.kind);
    available += weight;
    if (item.complete) earned += weight;
  }
  return available > 0 ? earned / available : 0;
}

export function weekCrowned(items) {
  return items.some((item) => item.kind === "progress_photos" && item.complete);
}
